<div class="wpm-wrapper">

  <!-- Header -->
  <div class="wpm-header">
    <div class="wpm-header-icon">
      <i class="fa-brands fa-whatsapp"></i>
    </div>
    <div class="wpm-header-text">
      <h2 class="wpm-title">Template Parameters</h2>
      <p class="wpm-subtitle">Map values for <strong>{{ data.campaignName }}</strong></p>
    </div>
  </div>

  <!-- Info strip -->
  <div class="wpm-info" *ngIf="params.length > 0">
    <i class="fa-solid fa-circle-info"></i>
    <span>
      Each row maps in order &mdash; Row 1 &rarr; <code ngNonBindable>{{1}}</code>,
      Row 2 &rarr; <code ngNonBindable>{{2}}</code>, and so on.
    </span>
  </div>

  <!-- Param rows -->
  <div class="wpm-params" *ngIf="params.length > 0">

    <div class="wpm-param-header-row">
      <span class="wpm-col-label">Slot</span>
      <span class="wpm-col-label">Type</span>
      <span class="wpm-col-label">Value</span>
      <span class="wpm-col-label"></span>
    </div>

    <div *ngFor="let param of params; let i = index" class="wpm-param-row">

      <div class="wpm-slot-badge">
        {{ '{{' + (i + 1) + '}}' }}
      </div>

      <select class="wpm-select" [(ngModel)]="param.type">
        <option value="field">Customer Field</option>
        <option value="static">Static Value</option>
      </select>

      <select *ngIf="param.type === 'field'" class="wpm-select wpm-value-input" [(ngModel)]="param.value">
        <option *ngFor="let field of data.customerFields" [value]="field">{{ field }}</option>
      </select>

      <input *ngIf="param.type === 'static'" class="wpm-input wpm-value-input" [(ngModel)]="param.value"
        type="text" placeholder="Enter static text…" />

      <button class="wpm-remove-btn" (click)="removeParam(i)" title="Remove row">
        <i class="fa-solid fa-trash-can"></i>
      </button>

    </div>

  </div>

  <!-- Empty state (no params) -->
  <div class="wpm-empty-state" *ngIf="params.length === 0">
    <div class="wpm-empty-icon">
      <i class="fa-solid fa-message"></i>
    </div>
    <p class="wpm-empty-title">No parameters defined</p>
    <p class="wpm-empty-desc">
      Template will be sent as-is with no variable substitution.<br>
      Click <strong>Add Parameter</strong> if your template has variables.
    </p>
  </div>

  <!-- Add row -->
  <button class="wpm-add-btn" (click)="addParam()">
    <i class="fa-solid fa-circle-plus"></i> Add Parameter
  </button>

  <div class="wpm-divider"></div>

  <!-- Footer actions -->
  <div class="wpm-footer">
    <button class="wpm-cancel-btn" (click)="cancel()">
      <i class="fa-solid fa-xmark"></i> Cancel
    </button>
    <button class="wpm-send-btn" (click)="confirm()">
      <i class="fa-brands fa-whatsapp"></i> Send Messages
    </button>
  </div>

</div>
